export default __webpack_public_path__ + "static/media/ai.9d4d5588.jpg";